import { atom } from "recoil"

export const migrationRequestIdState = atom({
  key: "atoms/contact/migrationRequestIdState",
  default: 0,
})
